import { type HTMLProps, forwardRef } from 'react'
import { cn } from '#app/utils/misc.js'

export type SurfaceProps = HTMLProps<HTMLDivElement> & {
	withShadow?: boolean
	withBorder?: boolean
}

export const Surface = forwardRef<HTMLDivElement, SurfaceProps>(
	(
		{ children, className, withShadow = true, withBorder = true, ...props },
		ref,
	) => {
		const surfaceClass = cn(
			className,
			'rounded-lg bg-white',
			withShadow ? 'shadow-sm' : '',
			withBorder ? 'border border-neutral-200' : '',
		)

		return (
			<div className={surfaceClass} {...props} ref={ref}>
				{children}
			</div>
		)
	},
)

Surface.displayName = 'Surface'
